

import React from "react";


const SuspenseIconLoader = ()=>{
	return(
		<span><svg xmlns="http://www.w3.org/2000/svg"  width="10" height="10" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
		<circle cx="50" cy="50" r="32" strokeWidth="8" stroke="#35383d" strokeDasharray="50.26548245743669 50.26548245743669" fill="none" strokeLinecap="round">
			<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
		</circle>
		</svg>
		</span>
	)
}
export default SuspenseIconLoader;